import { TextInputField, Select, AutoCompleteWithClientSideSearch, AutoCompleteWithServerSideSearch, KeyValueField, TwinTreeview } from './FormFields';
export default {
  name: 'DynamicInputContainer',
  components: {
    TextInputField,
    Select,
    AutoCompleteWithClientSideSearch,
    AutoCompleteWithServerSideSearch,
    KeyValueField,
    TwinTreeview
  },
  props: {
    currentFieldConfig: {
      type: Object,
      default: null
    },
    inputValues: {
      type: Object,
      required: true
    },
    selectOptions: {
      type: Array,
      default: () => []
    },
    isLoadingOptions: {
      type: Boolean,
      default: false
    },
    keyOptions: {
      type: Array,
      default: () => []
    },
    valueOptions: {
      type: Array,
      default: () => []
    },
    isLoadingKeyOptions: {
      type: Boolean,
      default: false
    },
    isLoadingValueOptions: {
      type: Boolean,
      default: false
    },
    searchTerm: {
      type: String,
      default: ''
    },
    keySearchTerm: {
      type: String,
      default: ''
    },
    valueSearchTerm: {
      type: String,
      default: ''
    },
    canLoadMoreKeyOptions: {
      type: Boolean,
      default: false
    },
    isLoadingMoreKeyOptions: {
      type: Boolean,
      default: false
    },
    canLoadMore: {
      type: Boolean,
      default: false
    },
    isLoadingMore: {
      type: Boolean,
      default: false
    },
    canAddRule: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    showCondition: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dynamicInputCols() {
      const baseColumns = 12;
      const categoryColumns = 3;
      const conditionColumns = this.showCondition ? 2 : 0;
      return baseColumns - categoryColumns - conditionColumns;
    },
    hasKeyOptions() {
      const config = this.currentFieldConfig;
      return config && config.type === 'keyValue' && (config.keyOptions || config.fetchKeyOptions);
    },
    hasValueOptions() {
      const config = this.currentFieldConfig;
      return config && config.type === 'keyValue' && (config.valueOptions || config.fetchValueOptions);
    }
  }
};